import React, { useState } from "react";
import "./FaqSection.scss";

// Inline chevron — avoids relying on an external asset that may not be uploaded
const ChevronIcon = ({ open }) => (
    <svg
        className={`lv2-faq-chevron${open ? " lv2-faq-chevron-open" : ""}`}
        width="40" height="40" viewBox="0 0 40 40"
        fill="none" xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="20" cy="20" r="19.5" stroke="rgba(255,255,255,0.15)" />
        <path d="M13 16.5L20 23.5L27 16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FAQS = [
    {
        question: "What is ALL3D?",
        answer: "ALL3D is an AI-powered product visualization platform that helps ecommerce teams create high-quality product images, videos, and 3D assets at scale. Our workflow combines AI generation with 3D precision tools to deliver accurate, on-brand visuals for any channel.",
    },
    {
        question: "How accurate are ALL3D's AI-generated product images and video?",
        answer: "Our AI models are trained specifically for ecommerce product visualization, delivering industry-leading accuracy for colors, textures, and proportions. When paired with 3D precision editing, you can achieve photorealistic results that are indistinguishable from traditional photography.",
    },
    {
        question: "Can AI-generated images replace product photography?",
        answer: "For many use cases, yes. ALL3D produces studio-quality imagery at a fraction of the time and cost of traditional photography. Teams use our platform to eliminate photoshoots for catalog images, lifestyle scenes, and variant shots — while maintaining full creative control over every detail.",
    },
    {
        question: "What are the main features of the ALL3D platform?",
        answer: "ALL3D includes AI scene generation, 4K image and video output, 3D model creation and editing, a product configurator, AR view-in-room experiences, team collaboration and review tools, and direct publishing to Shopify, Amazon, and other channels — all in one workflow.",
    },
    {
        question: "What plans does ALL3D offer?",
        answer: "We offer credit-based packages starting at $20/month, suitable for individuals, small businesses, and enterprise teams. All plans include access to our full AI workflow. Contact us for custom enterprise pricing and volume discounts.",
    },
];

const FaqSection = () => {
    const [openIdx, setOpenIdx] = useState(null);

    const toggle = (i) => setOpenIdx(prev => (prev === i ? null : i));

    return (
        <div className="lv2-faq-wrapper">

            {/* ── Heading ──────────────────────────────────────────────────────── */}
            <div className="lv2-faq-heading">
                <h2 className="manrope f-50 w-600 lh-60 white lv2-faq-title">
                    Frequently asked questions
                </h2>
            </div>

            {/* ── Accordion list ───────────────────────────────────────────────── */}
            <div className="lv2-faq-list">
                {FAQS.map((faq, i) => (
                    <div key={i} className="lv2-faq-item">
                        <button
                            className="lv2-faq-row"
                            onClick={() => toggle(i)}
                            aria-expanded={openIdx === i}
                        >
                            <span className="manrope f-20 w-500 lh-28 white lv2-faq-question">
                                {faq.question}
                            </span>
                            <ChevronIcon open={openIdx === i} />
                        </button>
                        <div className={`lv2-faq-answer-wrap${openIdx === i ? " lv2-faq-answer-wrap-open" : ""}`}>
                            <p className="manrope f-16 w-400 lh-24 lv2-faq-answer">
                                {faq.answer}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default FaqSection;
